import { RecommendedRailSource } from '../../GraphQL/Queries/types';

const generateRecommendedContentQueryParams = (
  contentId: string,
  country: string,
  translation: string,
  region: string,
  languages: string
) => {
  const queryParams = {
    filter: {
      id: contentId,
      sourceType: RecommendedRailSource.ConsumptionPage,
      limit: 25,
      country,
      translation,
      languages,
      region
    }
  };
  return queryParams;
};

export default generateRecommendedContentQueryParams;
